import { Api } from 'utils';

class ProfileService {
	
	static get = async (params?: any) => Api.createResponse('profile/get',params);
	static getApi = async (params?: any) => Api.createResponse('profile/get-api',params);
	static update = async (params?: any) => Api.createResponse('profile/save',params);
	static password = async (params?: any) => Api.createResponse('profile/password',params);
	static generateToken = async (params?: any) => Api.createResponse('profile/generate-token',params);

}

export default ProfileService;